import { render } from "./AdminSidebarSection.vue?vue&type=template&id=46228eef"
import script from "./AdminSidebarSection.vue?vue&type=script&lang=js"
export * from "./AdminSidebarSection.vue?vue&type=script&lang=js"

import "./AdminSidebarSection.vue?vue&type=style&index=0&id=46228eef&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__